
import { connect } from 'react-redux';
import { getMessages } from '~/state/ducks/ui/selectors';
import actions from '~/state/ducks/ui/actions';

import toJS from '~/views/enhancers/toJS';

import FlashIt from '../components/FlashIt';


const mapStateToProps = state => ({
    messages: getMessages(state),
});

const mapDispatchToProps = {
    handleRemoveMessage: message_id => actions.flash.remove(message_id),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(toJS(FlashIt));
